// Shared credential-number format validation.
// Returns an error string when the credential is invalid for the given role,
// or null when it passes. Logic mirrors the BACB registry number formats.
export function validateCredentialFormat(credential, role) {
  const val = (credential || "").trim();
  if (!val) return "Enter your credential number first.";
  if (val.length < 4) return "Credential number is too short.";
  if (!/^[A-Z0-9-]+$/i.test(val)) return "Only letters, numbers, and hyphens are allowed.";
  if (role === "rbt" && !/^RBT-\d{2}-\d{2,}$/i.test(val))
    return "RBT credential numbers use BACB format: RBT-XX-XXXXX(X) (e.g. RBT-23-12345).";
  if (role === "bcba" && !/^\d[\d-]{3,}$/i.test(val))
    return "BCBA credential numbers are numeric with hyphens (e.g. 1-12-12345).";
  if (role === "bcaba" && !/^\d[\d-]{3,}$/i.test(val))
    return "BCaBA credential numbers are numeric with hyphens (e.g. 1-12-12345).";
  return null;
}
